import { DEFAULT_LAYOUT } from '@/router/base';

export default {
  path: '/download',
  component: DEFAULT_LAYOUT,
  meta: {
    title: '下载',
    icon: 'SfTag',
    permission: ['*'],
    order: 0,
  },
  children: [
    {
      path: '',
      name: '/download',
      component: () => import(/* webpackChunkName:'download' */ '@/pages/download.vue'),
      meta: {
        title: '下载',
        permission: ['*'],
        activeMenu: '/download',
        hideInMenu: true,
      },
    },
  ],
};
